module.exports = __webpack_public_path__ + "media/icons/add-335c101b.png";